import { api } from "./index";

//!---------------------------//
//! --- report api routes --- //
//!---------------------------//

// --- reports --- //
export const sendReport = (newReport) => api.post("/report", newReport);
